import React, {useEffect, useState} from "react";
import {Platform} from "../layouts/Platform";
import {Box, Grid, Stack, Typography} from "@mui/material";
import 'react-circular-progressbar/dist/styles.css';
import {useUserStore} from "../store/userStore";
import {useTestStore} from "../store/testStore";
import {TestBox} from "../components/AreaPersonale/TestBox";
import {daciaTheme} from "../theme/daciaTheme";

export const AreaPersonale = () => {
    const {user} = useUserStore()
    const {test} = useTestStore()
    const [percentage, setPercentage] = useState(0);

    useEffect(() => {
        if(test && test.length>0){
            setPercentage(parseInt(test[0].total_score))
        }
    }, [])

    const SessionTests = ({session, title}) => {
        const sessionTests = test?.filter(t => t.session_id === session)

        return (
            <Box sx={{pb:3}}>
                <Typography fontWeight={'bold'} sx={{pb: 2}} color={daciaTheme.palette.primary.main}>
                    {title}
                </Typography>
                {sessionTests && sessionTests.length>0 ?
                    <Stack spacing={2}>
                        {sessionTests.map((item, index) =>
                            <TestBox test={item} key={index} last={index === sessionTests.length - 1}/>
                        )}
                    </Stack>
                    :
                    <Typography color={'#848484'}>
                        Non hai ancora sostenuto alcun test in questa sessione
                    </Typography>
                }
            </Box>
        )
    }

    return (
        <Platform refresh>
            <Box>
                <Box>
                    <Typography fontFamily={'Dacia Block Extended'} variant={'h6'} sx={{pb: 2}}>
                        Informazioni personali
                    </Typography>
                    <Typography fontFamily={'Dacia Block Extended'} variant={'h5'} color={daciaTheme.palette.primary.main}>
                        {user.nome} {user.cognome}
                    </Typography>
                    <Typography fontFamily={'Dacia Block Extended'} color={daciaTheme.palette.primary.main}>
                        {user.email}
                    </Typography>
                </Box>
            </Box>
            <Box sx={{pt:4}}>
                <Typography fontFamily={'Dacia Block Extended'} sx={{pb: 2}} variant={'h6'}>
                    Ultimi test svolti
                </Typography>
                <SessionTests session={'1126'} title={'Test n. 8 - REBRANDING STRATEGY (sessione 8 - Novembre 2026)'}/>
                <SessionTests session={'0326'} title={'Test n. 7 - REBRANDING STRATEGY (sessione 7 - Marzo 2026)'}/>
                <SessionTests session={'1025'} title={'Test n. 6 - REBRANDING STRATEGY (sessione 6 - Ottobre 2025)'}/>
                <SessionTests session={'0525'} title={'Test n. 5 - REBRANDING STRATEGY (sessione 5 - Maggio 2025)'}/>
                <SessionTests session={'1024'} title={'Test n. 4 - REBRANDING STRATEGY (sessione 4 - Ottobre 2024)'}/>
                <SessionTests session={'0524'} title={'Test n. 3 - REBRANDING STRATEGY (sessione 3 - Maggio 2024)'}/>
                <SessionTests session={'1023'} title={'Test n. 2 - REBRANDING STRATEGY (sessione 2 - Ottobre 2023)'}/>
                <SessionTests session={'0723'} title={'Test n. 1 - REBRANDING STRATEGY (sessione 1 - Luglio 2023)'}/>
            </Box>
        </Platform>
)
}
